/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICTS,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );

export const getSingleDistrict = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_DISTRICT,
    `api/v1/rpt/administrator/settings/districts/${id}`,
    payload,
    callback
  );

export const createDistrict = (payload, callback) =>
  req.create(
    c.CREATE_DISTRICT,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateDistrict = (id, payload, callback) =>
  req.update(
    c.UPDATE_DISTRICT,
    `api/v1/rpt/administrator/settings/districts/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeDistrict = (id, payload, callback) =>
  req.remove(
    c.REMOVE_DISTRICT,
    `api/v1/rpt/administrator/settings/districts/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE_LIST,
    'api/v1/administrators/address/provinces',
    payload,
    callback
  );

